import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { CommonService } from "./../../services/common.service";
import { ToastrService } from "ngx-toastr";
import { BaseComponent } from "../../../app/pages/base.component";
import { FileuploadService } from "../../services/fileupload.service";
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-resources-mdl',
  templateUrl: './resources-mdl.component.html',
  styleUrls: ['./resources-mdl.component.css']
})
export class ResourcesMdlComponent extends BaseComponent {

  @Input() approveData;
  resourcesLst: any[] = [];

  constructor(
    CommonService: CommonService, toastr: ToastrService,
    public actMdl: NgbActiveModal,
    private FileuploadService: FileuploadService
  ) {
    super(CommonService, toastr);
  }

}
